module.exports = __webpack_public_path__ + "media/TourAddress.c3f7419b.svg";